// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"MealsPop_ConfirmationPop__VuN0Y","modalBody":"MealsPop_modalBody__Tvnas"};